/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'health-monitor';
const componentName = 'http-health-monitor-config';
const prefix = `${moduleName}.${componentName}`;

export const clientRequestHeaderInputLabel = `${prefix}.clientRequestHeaderInputLabel`;
export const clientRequestHeaderInputPlaceholder = `${prefix}.clientRequestHeaderInputPlaceholder`;
export const clientRequestBodyInputLabel = `${prefix}.clientRequestBodyInputLabel`;
export const clientRequestBodyInputPlaceholder = `${prefix}.clientRequestBodyInputPlaceholder`;
export const useExactRequestInputLabel = `${prefix}.useExactRequestInputLabel`;
export const serverResponseDataInputLabel = `${prefix}.serverResponseDataInputLabel`;
export const serverResponseDataInputPlaceholder = `${prefix}.serverResponseDataInputPlaceholder`;
export const responseCodeInputPlaceholder = `${prefix}.responseCodeInputPlaceholder`;
export const enableSslAttributesLabel = `${prefix}.enableSslAttributesLabel`;
export const usePoolSNIServerNameLabel = `${prefix}.usePoolSNIServerNameLabel`;
export const http2Label = `${prefix}.http2Label`;
export const http2sLabel = `${prefix}.http2sLabel`;
export const selectHttpMethodLabel = `${prefix}.selectHttpMethodLabel`;
export const requestHeaderPathLabel = `${prefix}.requestHeaderPathLabel`;
export const headerPathPlaceHolder = `${prefix}.headerPathPlaceHolder`;
export const httpHeadersLabel = `${prefix}.httpHeadersLabel`;
export const headerLabel = `${prefix}.headerLabel`;
export const headerPlaceholder = `${prefix}.headerPlaceholder`;

export const ENGLISH = {
    [clientRequestHeaderInputLabel]: 'Client Request Header',
    [clientRequestHeaderInputPlaceholder]: 'Enter Client Request Header',
    [clientRequestBodyInputLabel]: 'Client Request Body',
    [clientRequestBodyInputPlaceholder]: 'Enter Client Request Body',
    [useExactRequestInputLabel]: 'Use Exact Request',
    [serverResponseDataInputLabel]: 'Server Response Data',
    [serverResponseDataInputPlaceholder]: 'Enter Server Response Data',
    [responseCodeInputPlaceholder]: 'Select Response Code',
    [enableSslAttributesLabel]: 'Enable SSL Attributes',
    [usePoolSNIServerNameLabel]: 'Use SNI Server Name From Configured Pool',
    [http2Label]: 'HTTP2',
    [http2sLabel]: 'HTTP2S',
    [selectHttpMethodLabel]: 'Select HTTP Method',
    [requestHeaderPathLabel]: 'Request Header Path',
    [headerPathPlaceHolder]: 'Enter Header Path',
    [httpHeadersLabel]: 'HTTP Headers',
    [headerLabel]: 'Header',
    [headerPlaceholder]: 'Enter Header',
};
